/* eslint-disable no-undef */
import React from 'react'
import { Widget, Divider } from '@duik/it'
import styled from '@emotion/styled'
import CloseXIcon from './CloseXIcon'

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(19, 24, 32, 0.6);
  display: flex;
  justify-content: center;
  z-index: 1;
  align-items: center;
`

const WidgetWrapper = styled.div`
  max-width: 540px;
  max-height: 583px;
  width: 100%;
  height: 100%;
  background-color: white;
  border-radius: 5px;
`

const HeadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Heading = styled.h3`
  margin: 25px;
  color: #3e3f42;
`

const AltHeading = styled.div`
  height: 78px;
  display: flex;
  align-items: center;
`

const BannerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 100%;
  height: 65px;
  background-color: #fbfbfd;
  padding: 0 30px;
`

const BannerText = styled.p`
  font-size: 16px;
  color: #3e3f42;
`

const BannerTextRight = styled.p`
  margin: 0;
  font-size: 16px;
  color: #3e3f42;
`

type Props = {
  title: string | JSX.Element
  handleCloseModal: () => void
  children?: any
  bannerText?: string | JSX.Element
  bannerTextRight?: string | JSX.Element
}

const CreateNewModal = ({
  title,
  handleCloseModal,
  children,
  bannerText,
  bannerTextRight
}: Props) => (
  <Container>
    <WidgetWrapper>
      <Widget>
        <HeadingWrapper>
          {typeof title === 'string' ? (
            <Heading>{title}</Heading>
          ) : (
            <AltHeading>{title}</AltHeading>
          )}
          <CloseXIcon onClick={handleCloseModal} />
        </HeadingWrapper>
        <Divider />
        {bannerText && (
          <>
            <BannerWrapper>
              <BannerText>{bannerText}</BannerText>
              <BannerTextRight>{bannerTextRight}</BannerTextRight>
            </BannerWrapper>
            <Divider />
          </>
        )}
        {children}
      </Widget>
    </WidgetWrapper>
  </Container>
)

export default CreateNewModal
